
import {clsx} from 'external/clsx'
import { FC, useMemo } from 'external/react'

import getImage from 'resources/assets'

type PaymentMethodProps = {
    className?: string
    showLabel?: boolean
    card: string
    last4: string
}

const PaymentMethod:FC<PaymentMethodProps> = props => {

    const {className, card, last4, showLabel = true} = props

    const src = useMemo(() => getImage(`/payment-method/${card}.png`, `/payment-method/default.png`), [card])

	return (
       <div className={clsx('d-flex', className)}>
            {showLabel && <div className='text-capitalize fw-bold-500 mb-1'>Método de pago</div>}
            <div className='d-flex'>
                <img src={src} alt={card} title={card} className='img-fluid mr-1' style={{ width: '40px', }} />
                <span className='fn-s-14'>{last4}</span>
            </div>
        </div>
    )
}

export {PaymentMethod as default}